import { generateRandomString } from '../randomGen';
export class LineAuth {
  clientId: string;
  callbackURL: string;
  CookieManager: any;

  constructor(clientId: string, callbackURL: string, cookieManager: any) {
    this.clientId = clientId;
    this.callbackURL = callbackURL;
    this.CookieManager = cookieManager;
  }

  generateLoginUrl(): URL {
    const randomString = generateRandomString(5);

    this.CookieManager.setOAuthStateValue(randomString);

    return new URL(
      `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.callbackURL}&state=${randomString}&scope=profile%20openid%20email&nonce=`
    );
  }
  userLogin() {
    window.location.assign(this.generateLoginUrl());
  }

  static get lineQueryParams() {
    return ['code', 'state', 'error', 'error_description'];
  }
}
